import { supabase } from "./supabase";

// createKidProfile — thin client wrapper around the kid-create edge
// function. Returns { kid_profile_id } on success, throws on failure.
//
// Post-migration (kid-as-subset-of-parent): the kid is a row in
// `profiles` owned by the parent via a `relationships` family link.
// NO auth.users row, NO email, NO magic link. The parent enters the
// kid's "mode" via a client-side context switch (App.jsx's
// activeKidId state), not by signing in as the kid.
export async function createKidProfile({ name, birthYear, petId, petSlug } = {}) {
  const { data, error } = await supabase.functions.invoke("kid-create", {
    body: {
      name,
      birth_year: typeof birthYear === "number" ? birthYear : null,
      pet_id:   petId   || null,
      pet_slug: petSlug || null,
    },
  });
  if (error) throw error;
  if (data?.error) throw new Error(data.error);
  return data;  // { kid_profile_id }
}
